import defaultOptions from './defaults';
import createInstance from './instance';
import { writeTemplate } from './render';
import { validateOptions } from './validators';
import { applyOnFocusListener, removeOnFocusListener } from './listeners';

import '../scss/main.scss';

const MCDatepicker = (() => {
	let datepickers = [];
	let calendarNodes = null;

	const initCalendar = (instanceOptions) => {
		if (calendarNodes) return;
		calendarNodes = writeTemplate(instanceOptions);
	};

	const open = (uid) => {
		// find the instance based on it's unique id
		const activeInstance = datepickers.find(({ _id }) => _id === uid);
		if (!activeInstance && !calendarNodes) return;
		calendarNodes.calendarStates.open(activeInstance);
		var calendarDiv = document.querySelector(".mc-calendar");
		var btnCancel = calendarDiv.querySelector("#mc-btn__cancel");
		btnCancel.innerHTML = activeInstance.options.getTranslation("import_Cancel");
		var btnSubmit = calendarDiv.querySelector("#mc-btn__ok");
		btnSubmit.innerHTML = activeInstance.options.getTranslation("import_Submit");
	};

	const close = () => {
		if (!calendarNodes) return;
		const { calendarStates } = calendarNodes;
		calendarStates.close();
	};

	const create = (options = {}) => {
		// validate options and merge them with de default Options
		const instanceOptions = validateOptions(options, defaultOptions);
	
		if(instanceOptions.selectedDate){	
			const selectedDate = new Date(instanceOptions.selectedDate);
			instanceOptions.selectedTime = selectedDate.getHours() + ((selectedDate.getMinutes() == 0) ? 0 : .5);
			if(instanceOptions.scheduled_type == 2){
				instanceOptions.selectedDate = false;
				instanceOptions.selectedWeekday = selectedDate.getDay();
			}
		}
		else{
			instanceOptions.selectedTime = null
		}
		
		// initiate the calendar instance once
		initCalendar(instanceOptions);

		// create instance
		const instance = createInstance(MCDatepicker, calendarNodes, instanceOptions);
		if(instanceOptions.selectedDate){
			instance.pickedDateArray.push(instanceOptions.selectedDate);
		}
		// push fresh created instance to instances array
		datepickers.push(instance);
		// add event listener to the linked input
		applyOnFocusListener(instance);

		return instance;
	};

	const remove = (uid) => {
		// find the instance based on it's unique id
		const instance = datepickers.find(({ _id }) => _id === uid);
		if (!datepickers.length || !instance) return;
		// remove the onFocus listener
		removeOnFocusListener(instance);
		// Remove the instance from the datepickers array
		datepickers.splice(datepickers.indexOf(instance), 1);

		if (!datepickers.length) {
			const { calendar } = calendarNodes;
			calendar.parentNode.removeChild(calendar);
			calendarNodes = null;
		}
	};
	return { create, remove, open, close };
})();
export default MCDatepicker;
